export default "__VITE_ASSET__CeomP5Od__"